import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from '../i18n/pl';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";

@Component({
    selector: 'fiscal-printer-inactive-dialog',
    templateUrl: './fiscalPrinterInactiveDialog.component.html',
    styleUrls: ['./fiscalPrinterInactiveDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class FiscalPrinterInactiveDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    loading: boolean;

    constructor(
        public matDialogRef: MatDialogRef<FiscalPrinterInactiveDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        public _matDialog: MatDialog,
    ) {

        this.translationLoader.loadTranslations(polish);
    }
}
